import { usePageInfo } from '../config/queries'
import { useActionable } from './useActionable'
import { useCustomDomain } from './useCustomDomain'
import { useHasSidebar } from './useHasSidebar'

const sidebarStickyTopPx = (hasSubheader: boolean, currentAction: boolean) => {
  // Sidebar layouts have no top nav. The events/loot subheader is min-h-[40px].
  const subheaderOffset = hasSubheader ? 40 : 0
  if (currentAction) {
    // actionbar (32px)
    return 32 + subheaderOffset
  }

  return subheaderOffset
}

export const useStickyTopPx = (hasSubheader = false) => {
  const {
    data: { user },
  } = usePageInfo()
  const { customDomain } = useCustomDomain()
  const hasSidebar = useHasSidebar()
  const { currentAction } = useActionable(user)

  if (customDomain) {
    if (hasSidebar) {
      return sidebarStickyTopPx(hasSubheader, !!currentAction)
    }

    if (currentAction) {
      return hasSubheader ? 125 : 88
    }

    return hasSubheader ? 94 : 56
  }

  if (currentAction) {
    return 128
  }

  return 97
}

export const useStickyTop = (hasSubheader = false) => {
  const {
    data: { user },
  } = usePageInfo()
  const { customDomain } = useCustomDomain()
  const hasSidebar = useHasSidebar()
  const { currentAction } = useActionable(user)

  if (customDomain) {
    if (hasSidebar) {
      if (currentAction) {
        // actionbar (32px) + subheader (40px) when present
        return hasSubheader ? 'top-[72px]' : 'top-[32px]'
      }

      // subheader (40px) when present
      return hasSubheader ? 'top-[40px]' : 'top-0'
    }

    if (currentAction) {
      // Top navigation (56px) + subheader (38px) + actionbar (32px) - negative margin (1px)
      return hasSubheader ? 'top-[125px]' : 'top-[88px]'
    }

    // Top navigation (56px) + subheader (38px)
    return hasSubheader ? 'top-[94px]' : 'top-[56px]'
  }

  if (currentAction) {
    // Top navigation (56px) + subheader (38px) + actionbar (31px) + margin (3px)
    return 'top-[128px]'
  }

  // Top navigation (56px) + subheader (38px) + margin (3px)
  return 'top-[97px]'
}
